import { NgModule } from '@angular/core';
import { CART_BASE_FEATURE } from '@spartacus/cart/base/root';
import { CHECKOUT_CORE_FEATURE, CHECKOUT_FEATURE, CheckoutEventModule } from '@spartacus/checkout/base/root';
import { CmsConfig, provideConfig, provideConfigFactory } from '@spartacus/core';
import { defaultCheckoutRoutingConfig } from './config/default-checkout-routing-config';
import { defaultCheckoutConfig } from './config/kn-br-checkout-config';

export const CHECKOUT_BASE_CMS_COMPONENTS: string[] = [
  'CheckoutOrchestrator',
  'CheckoutOrderSummary',
  'CheckoutProgress',
  'CheckoutProgressMobileBottom',
  'CheckoutProgressMobileTop',
  'CheckoutDeliveryMode',
  'CheckoutPaymentDetails',
  'CheckoutPlaceOrder',
  'CheckoutReviewOrder',
  'CheckoutDeliveryAddress',
  'GuestCheckoutLoginComponent',
];

export function defaultCheckoutComponentsConfig() {
  const config: CmsConfig = {
    featureModules: {
      [CHECKOUT_FEATURE]: {
        cmsComponents: CHECKOUT_BASE_CMS_COMPONENTS,
        dependencies: [CART_BASE_FEATURE],
      },
      // by default core is bundled together with components
      [CHECKOUT_CORE_FEATURE]: CHECKOUT_FEATURE,
    },
  };
  return config;
}

@NgModule({
  imports: [CheckoutEventModule],
  providers: [
    provideConfig(defaultCheckoutRoutingConfig),
    provideConfig(defaultCheckoutConfig),
    provideConfigFactory(defaultCheckoutComponentsConfig),
  ],
})
export class KnBrCheckoutRootModule { }
